/**
 * Created by vladislav on 29.08.2019
 */

const Dialogue = function (data, options) { 
    cleverapps.EventEmitter.call(this);

    this.options = options || {};
    this.parentScene = options.parentScene;
    this.imageBundle = options.imageBundle;

    this.autoScroll = 3;
    if (this.options.autoScroll !== undefined) {
        this.autoScroll = this.options.autoScroll;
    }
    this.data = Array.isArray(data) ? data : [data];
    this.stage = -1;

    this.stageData = this.data[0];

    const personsBundles = [];
    data.forEach((step) => {
        ["person", "person2"].forEach((key) => {
            if (!step[key]) {
                return;
            }
            const person = cleverapps.persons.getRole(step[key].role || step[key]);
            personsBundles.push(person && person.bundle);
        });
    });

    this.bundlesToLoad = cleverapps.unique(["dialogues", "vertical_dialogue"].concat(personsBundles).concat(this.imageBundle)).filter((name) => bundles[name]);
};

Dialogue.prototype = Object.create(cleverapps.EventEmitter.prototype);
Dialogue.prototype.constructor = Dialogue;

Dialogue.prototype.run = function () {
    if (!cleverapps.focusManager.isFocused()) {
        console.log("Dialogue:", this.data);
        cleverapps.focusManager.debugMessage("Trying to show dialogue without user focus!");
    }

    this.focus = cleverapps.focusManager.focus;

    this.next();
};

Dialogue.prototype.isStarted = function () {
    return this.stage !== -1;
};

Dialogue.prototype.finishClose = function () {
    if (this.closeCallback) {
        this.closeCallback();
        delete this.closeCallback;
    }
    this.trigger("afterClose");
};

Dialogue.prototype.close = function (callback) {
    if (this.closing) {
        return;
    }
    this.closing = true;

    this.closeCallback = callback;
    this.trigger("close", !this.options.showUp);
};

Dialogue.prototype.next = function (delay) {
    clearTimeout(this.nextTimeout);

    if (cleverapps.focusManager.focus !== false && cleverapps.focusManager.focus !== this.focus) {
        return;
    }

    if (delay) {
        this.nextTimeout = this.createTimeout(this.next.bind(this), delay * 1000);
        return;
    }

    if (this.stage < this.data.length - 1) {
        this.incStage();
    } else if (this.options.autoClose) {
        this.close();
    }
};

Dialogue.prototype.incStage = function () {
    this.stage++;
    this.stageData = this.data[this.stage];
    this.onChangeStage();
};

Dialogue.prototype.createTimeout = function (callback, delay) {
    return new cleverapps.CountDown(delay, {
        onFinish: function () {
            if (!this.closing) {
                callback();
            }
        }.bind(this)
    });
};

Dialogue.prototype.onChangeStage = function () {
    if (this.stageData.person === undefined) {
        this.stageData.person = "hero";
    }
    this.trigger("changedStage", this.stageData);

    if (this.stage === 0) {
        this.trigger("showUp", !this.options.showUp);
    }
};

Dialogue.prototype.onContentChanged = function (activeContent) {
    this.trigger("contentChanged", activeContent);
};